import { cn } from '@/utils/cn';

/**
 * A spinner is decoration around a state the surrounding element already announces
 * with `aria-busy`, so it is hidden from assistive technology rather than read out
 * as a nameless image.
 */
export const Spinner = ({ className }: { className?: string }) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="none"
    className={cn('h-4 w-4 animate-spin', className)}
  >
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" opacity="0.25" />
    <path
      d="M22 12a10 10 0 0 0-10-10"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);
